import React from 'react'
import { Field } from '../../form'
import { CurrencyInput, GenericNumberInput } from '../../utils/numberFormat'
import useDebouncedEffect from '../../utils/useDebouncedEffect'

const SumField = ({
  name,
  watchValue,
  setValue,
  className,
  control,
  isTotalHours,
  ...rest
}) => {
  useDebouncedEffect(setValue, [name, watchValue.toString()], 300)

  return (
    <Field
      name={name}
      disabled={true}
      inputType="textfield"
      inputComponent={isTotalHours ? GenericNumberInput : CurrencyInput}
      className={className}
      control={control}
      {...rest}
    />
  )
}

export default SumField
